// Inside Stock Item Category Options
export const CATEGORY_OPTIONS = [
    { label: 'Surgical Consumables', value: 'SURGICAL_CONSUMABLES' },
    { label: 'Injections & Medicines', value: 'INJECTIONS_MEDICINES' },
    { label: 'Peels & Neutralisers', value: 'PEELS_NEUTRALISERS' },
    { label: 'Masks', value: 'MASKS' },
    { label: 'Creams & Serums', value: 'CREAMS_SERUMS' },
    { label: 'Complimentary Cosmetic Kits', value: 'COMPLIMENTARY_COSMETIC_KITS' },
    { label: 'Machines & Equipment', value: 'MACHINES_EQUIPMENT' },
    { label: 'Other Clinic Stock', value: 'OTHER_CLINIC_STOCK' },
] as const;

// Filter Options
export const CATEGORY_FILTER_OPTIONS = CATEGORY_OPTIONS;

// Stock Level Filter Options
export const STOCK_LEVEL_FILTER_OPTIONS = [
    { label: 'Low Stock', value: 'LOW' },
    { label: 'Medium Stock', value: 'MEDIUM' },
    { label: 'High Stock', value: 'HIGH' },
] as const;


// Transaction Type Options
export const TRANSACTION_TYPE_OPTIONS = [
    { label: 'Purchase', value: 'PURCHASE' },
    { label: 'Usage', value: 'USAGE' },
] as const;

// Payment Type Options
export const PAYMENT_TYPE_OPTIONS = [
    { label: 'Cash', value: 'CASH' },
    { label: 'Gpay', value: 'GPAY' },

] as const;

// Stock Level Colors
export const STOCK_LEVEL_COLORS = {
    LOW: '#ff4d4f',
    MEDIUM: '#fa8c16',
    HIGH: '#52c41a',
} as const;

// Stock Level Thresholds
export const STOCK_LEVEL_THRESHOLDS = {
    LOW: 0.2, // 20% of max stock
    MEDIUM: 0.6, // 60% of max stock
} as const;

// Utility function to determine stock level
export const getStockLevel = (
    currentStock: number,
    minStock: number = 0,
    maxStock: number = 100
): 'LOW' | 'MEDIUM' | 'HIGH' => {
    if (currentStock <= minStock) {
        return 'LOW';
    } else if (currentStock <= (minStock + maxStock) / 2) {
        return 'MEDIUM';
    } else {
        return 'HIGH';
    }
};
